export const STICKY_BUTTON_ANCHOR_ID = 'scrolledToSection';
